const actions = {
  SET_STATE: 'menu/SET_STATE' as const,
  SET_POPUP: 'menu/SET_POPUP' as const,
  GET_DATA: 'menu/GET_DATA' as const,
  RELOAD: 'menu/RELOAD' as const,
  ADD_LISTENER: 'menu/ADD_LISTENER' as const,
  REMOVE_LISTENER: 'menu/REMOVE_LISTENER' as const,
  NOTIFY_LISTENER: 'menu/NOTIFY_LISTENER' as const,
}

export default actions
